module.exports = __webpack_public_path__ + "static/media/4 trojan horse greek mythology troy.1280x1492.6457e1b7.webp";